import { MakePaths } from "common/router/types";
import { MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";

import { CheckoutErrorSearch, KlarnaCheckoutSearch, CheckoutStep } from "../types";

const paths = {
  start: "/",
  detail: "/:step",
  confirmation: "/confirmed",
  error: "/error",
};

type CheckoutParams = {
  step: CheckoutStep;
};

type CheckoutPathDefinitions = {
  start: {};
  detail: { Params: CheckoutParams; Search: KlarnaCheckoutSearch };
  confirmation: {};
  error: { Search: CheckoutErrorSearch };
};

export type CheckoutPaths = MakePaths<CheckoutPathDefinitions>;

export const useCheckoutRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes({ ...opts }, [
    {
      path: paths.start,
      element: () => import("../components/CheckoutRoot"),
      pageName: "checkout",
      skipPageView: true,
    },
    {
      path: paths.confirmation,
      element: () => import("../components/OrderConfirmationPage"),
      pageName: "order_confirmation",
    },
    {
      path: paths.error,
      element: () => import("../components/CheckoutErrorPage"),
      pageName: "checkout_error",
    },
    {
      path: paths.detail,
      element: () => import("../components/Checkout"),
      pageName: (params) => `checkout_${params.step}`,
    },
  ]);
};

export const makeCheckoutUrls = (base: string) => {
  return makeUrls<CheckoutPathDefinitions>(base, {
    start: { path: paths.start, to: () => `/` },
    detail: { path: paths.detail, to: ({ step }) => `/${step}` },
    confirmation: { path: paths.confirmation },
    error: { path: paths.error },
  });
};
